module.exports = __webpack_public_path__ + "static/media/narwhal.d63ff59b.svg";